
import HeroBackground from './hero/HeroBackground';
import HeroContent from './hero/HeroContent';
import HeroVisual from './hero/HeroVisual';

const HeroSection = () => {
  return (
    <section className="pt-24 sm:pt-32 md:pt-36 lg:pt-32 pb-16 sm:pb-24 md:pb-24 px-4 sm:px-6 relative overflow-hidden md:min-h-screen flex items-center">
      <HeroBackground />
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-16 md:gap-12 lg:gap-16 w-full">
          <HeroContent />
          <HeroVisual />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
